var React = require('react');

var PaginationLink = React.createClass({
    render: function() {
        var paginationLinkStyle = {
            padding: '0px 8px',
            lineHeight: '26px'
        };

        var { className, event, children } = this.props;

        return (
            <li className={className}>
                <a href="#" onClick={event} style={paginationLinkStyle}>
                    {children}
                </a>
            </li>
        );
    }
});

var PaginationLinks = React.createClass({
    propTypes: {
        paginationData: React.PropTypes.shape({
            currentPage: React.PropTypes.number,
            numPages: React.PropTypes.number,
            numResults: React.PropTypes.number,
            perPage: React.PropTypes.number,
        }).isRequired,
        handleNextPageRequested: React.PropTypes.func.isRequired,
        numLinks: React.PropTypes.number.isRequired
    },
    onChangePage: function(pageNumber, e) {
        e.preventDefault();
        this.props.handleNextPageRequested(pageNumber);
    },
    render: function() {
        var paginationData = this.props.paginationData;
        var paginationLinks = [], btnEvent, btnClass;
        var preventDefault = e => e.preventDefault();

        var start =  paginationData.currentPage - 1 < 1 ? 1 : paginationData.currentPage - 1;
        var end = paginationData.currentPage + 1 > paginationData.numPages ? paginationData.numPages +1: paginationData.currentPage + 1;

        end = Math.max(end, this.props.numLinks); // show at least the numLinks props
        end = Math.min(end, paginationData.numPages); // don't show more links than the number of pages

        if(start == 1 && end == 1) {
            paginationLinks.push(
                <PaginationLink
                    key={1}
                    handleNextPageRequested={this.props.handleNextPageRequested}
                    className='active'
                    event={preventDefault}>
                    {1}
                </PaginationLink>
            );
        } else {
            for (var i = start; i < (end + 1); i++) {
                // If the button is for the current page then disable the event.
                if (paginationData.currentPage === i) {
                    btnClass = 'active';
                    btnEvent = preventDefault;
                } else {
                    btnClass = null;
                    btnEvent = this.onChangePage.bind(this, i);
                }
                paginationLinks.push(
                    <PaginationLink
                        key={i}
                        handleNextPageRequested={this.props.handleNextPageRequested}
                        className={btnClass}
                        event={btnEvent}>
                        {i}
                    </PaginationLink>
                );
            }
        }

        var canRequestPreviousPage = paginationData.numPages > 1 && paginationData.currentPage > 1;
        var previousLinkEvent = canRequestPreviousPage ? this.onChangePage.bind(this, paginationData.currentPage -1) : preventDefault;
        var previousLinkClass = canRequestPreviousPage ? '' : 'disabled';

        var startLinkEvent = canRequestPreviousPage ? this.onChangePage.bind(this, 1) : preventDefault;
        var startLinkClass = previousLinkClass;

        var canRequestNextPage = paginationData.numPages > paginationData.currentPage;
        var nextLinkEvent = canRequestNextPage ? this.onChangePage.bind(this, paginationData.currentPage +1) : preventDefault;
        var nextLinkClass = canRequestNextPage ? '' : 'disabled';

        var EndLinkEvent = canRequestNextPage ? this.onChangePage.bind(this, paginationData.numPages) : preventDefault;
        var EndLinkClass = nextLinkClass;

        // change pagination link widths and description label depending on size of pages
        if(paginationData.numPages > 99) {
            var pagePositionLabel = `${paginationData.currentPage} / ${paginationData.numPages}`;
        } else {
            var pagePositionLabel = `${paginationData.currentPage} of ${paginationData.numPages}`;
        }

        if(paginationData.numPages > 9 && paginationData.currentPage > 9) {
            var paginationLinkStyle = {
                padding: '0px 6px',
                lineHeight: '26px'
            };
        } else {
            var paginationLinkStyle = {
                padding: '0px 8px',
                lineHeight: '26px'
            };
        }

        return (
            <div className="pagination-links-wrapper">
                    <ul className="pagination pagination-links pagination-sm" style={this.props.style}>
                        <li onClick={startLinkEvent} className={startLinkClass}>
                            <a href="#" title="go to first page" style={paginationLinkStyle}><span><i className='fa fa-fast-backward'></i></span></a>
                        </li>
                        <li onClick={previousLinkEvent} className={previousLinkClass}>
                            <a href="#" title="previous" style={paginationLinkStyle}><span><i className='fa fa-chevron-left'></i></span></a>
                        </li>
                        {paginationLinks}
                        <li onClick={nextLinkEvent} className={nextLinkClass}>
                            <a href="#" title="next" style={paginationLinkStyle}><span><i className='fa fa-chevron-right'></i></span></a>
                        </li>
                        <li onClick={EndLinkEvent} className={EndLinkClass}>
                            <a href="#" title="go to last page" style={paginationLinkStyle}><span><i className='fa fa-fast-forward'></i></span></a>
                        </li>
                    </ul>
                <span className="label label-default pull-right pagination-position-label">{pagePositionLabel}</span>
            </div>
        );
    }
});

module.exports = PaginationLinks;


// WEBPACK FOOTER //
// ./app/components/paginator/PaginationLinks.js